import PosthogService from '~/services/posthog/PosthogService';

export interface ICandidateListCandidateClickedPayload {
  shiftId: string;
  /** 1-indexed row clicked. Undefined when the candidate isn't in the list, so no bogus 0 is sent. */
  candidateNumber?: number;
  /** Every candidate on the list the office clicked from. */
  candidateCount: number;
}

/**
 * Fires when an office clicks a candidate row on the redesigned Confirm Candidates
 * list (GOTU-8158).
 *
 * On that page it replaces `confirm_candidate:candidate_viewed`, but covers less. That
 * event fired on every candidate opened; this one fires on list clicks only. A candidate
 * opened without a click — the sole applicant, a deep link, a dashboard or Action Needed
 * card, a decline advancing to the next one — sends no impression on the redesigned page,
 * so its funnel starts here. The legacy screen keeps firing `candidate_viewed`, so the two
 * series stay one per screen; do not merge them in an insight while both screens are live.
 *
 * The keys are spelled as `toCandidatePositionProperties` spells them, so the click
 * joins to the confirm / decline / leave events by `shift_id` and `candidate_number`.
 *
 * Event: dental_portal:candidate_list:candidate_clicked
 */
export function fireCandidateListCandidateClicked(
  payload: ICandidateListCandidateClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:candidate_list:candidate_clicked', {
    shift_id: payload.shiftId,
    candidate_number: payload.candidateNumber,
    candidate_count: payload.candidateCount,
  });
}
